<template>
  <div class="tempo">
    <div id="slider-wraper">
      <vue-slider
        :value="tempo" 
        :contained="true"
        :min="30"
        :max="240"
        :duration="0.2"
        :drag-on-click="true"
        @change="onchange"/>
    </div>
    <div id="button-wraper">
      <span @click="onclick(-1)">-1</span>
      <div>
        <span>Tempo = {{tempo}}</span>
        <span>テンポを調節できます</span>
      </div>
      <span @click="onclick(+1)">+1</span>
      
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
  name: 'tempo',
  components: {
    VueSlider,
  },
  methods: {
    onclick: function(delta){
      this.onchange(this.tempo + delta);
    },
    onchange: function(value){
      this.$store.commit('tempoChange', {tempo: value});
    }
  },
  computed: {
    tempo: function(){
      return this.$store.state.tempo;
    }
  }
}
</script>

<style scoped>
.tempo{
  display: block;
  width: 100%;
}
#slider-wraper{
  position: relative;
  display: block;
  margin: 0.5rem auto 0.2rem;
  width: 80%;
  min-width: 280px;
}
#button-wraper{
  display: flex;
  justify-content: space-around;
  align-items: stretch;
}
#button-wraper > span{
  display: inline-block;
  box-sizing: border-box;
  width: 40px;
  height: 42px;
  margin: 3px 6px;
  padding: 8px;
  border-radius: 20%;
  border: 1px solid #cbe3ff;
  background-color: #edf7ff;
}
#button-wraper > div{
  display: block;
}
#button-wraper > div > span{
  display: block;
  position: relative;
}
#button-wraper > div > span:last-child{
  font-size: 0.75rem;
}
</style>
